"use strict";

import angular from "angular";
import uiRouter from "angular-ui-router";

import "restangular";

import errors from "dias/core/errors";
import notification from "dias/core/notification";

import KStatusfolge from "./kstatusfolge.service";

const modelsModule = angular.module("dias.statusfolgen.models", [
  "restangular",
  uiRouter,
  errors.name,
  notification.name
])

  .provider("KStatusfolge", KStatusfolge)
;

export default modelsModule;
